import React, { useEffect, useState } from 'react';

import '../shared.css';
import { CustomTooltipSmall } from '../CustomTooltip';
import { formatNombre } from 'utils/StringUtils';

const RED = '#EE3900';
const ORANGE = '#FF8D4B';
const GREEN = '#43B929';
const GREY = '#E0E0E0';

export const MyCustomBiggerReverseHighChats = (props) => {
    const [color, setColor] = useState(GREY);
    const [pourcentage, setPourcentage] = useState(0);
    const [displayValue, setDisplayValue] = useState(0);

    useEffect(() => {
        const value = parseFloat(props.value).toFixed(2);
        setDisplayValue(value);

        if (props.maxValue == 0 && value == 0) {
            setColor(GREEN);
        }
        else if (value <= 0) {
            setColor(RED);
        } else if (props.maxValue / 2 >= value) {
            setColor(ORANGE);
        } else {
            setColor(GREEN);
        }

        const percent = props.maxValue === 0 ? 0 : (value * 100) / props.maxValue;
        setPourcentage(percent);
    }, [props]);

    return (
        <div style={{ margin: "15px" }}>
            <CustomTooltipSmall
                title={
                    <span>
                        <p style={{ fontSize: "18px", fontWeight: "600" }}>{pourcentage.toFixed(2)} %</p>
                    </span>
                }
                placement="top"
            >
                <span>
                    <div
                        style={{
                            color,
                            fontSize: "22px",
                            fontWeight: "bold",
                            marginBottom: "8px"
                        }}
                        className={`text-progress text-${color}`}
                    >
                        {formatNombre(displayValue)} / {formatNombre(props.maxValue)} €
                    </div>
                    <div className="progress progress-custom-bigger" style={{ height: "28px", borderRadius: "12px" }}>
                        <div
                            className="progress-bar"
                            role="progressbar"
                            style={{
                                width: `${pourcentage}%`,
                                backgroundColor: color,
                                height: "100%",
                                borderRadius: "12px"
                            }}
                            aria-valuenow={pourcentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        ></div>
                    </div>
                </span>
            </CustomTooltipSmall>
        </div>
    );
};
